module.exports = __webpack_public_path__ + "static/media/second_medal.e2505abd.png";